export function init() {
	$('body').on('click', '.tour-next', function() {
		var diagram = $(this).parents('.tour-diagram-wrap');
		var itemCount = diagram.find('.tour-diagram-text-item').length;
		var existingActiveItem = parseInt(diagram.attr('data-active-item'));
		var nextItem = existingActiveItem + 1;
		if ($(this).attr('data-next-item')) {
			nextItem = $(this).attr('data-next-item');
		} else {
			if (existingActiveItem >= itemCount) {
				nextItem = 1;
			}
		}
		diagram.attr('data-active-item', nextItem);
	});
}
